/*
 * @Description:
 * @version:
 * @Author: xiexing
 * @Date: 2020-12-16 15:41:51
 * @LastEditors: wangsen03 wangsen03@zhuanzhuan.com
 * @LastEditTime: 2024-10-31 17:30:22
 */
module.exports = [
  {
    /***
     * 新消息通知页面
     */
    path: '/message-notification',
    name: 'message-notification',
    component: () => import('@views/message-notification/index.vue')
  },
  {
    /***
     * 内部调式专用首页
     */
    path: '/debugging-index',
    redirect: '/debugging-index',
    component: () => import('@views/index/index.vue'),
    children: [
      {
        path: '/debugging-index',
        name: 'debugging-index',
        meta: {
          title: '内部调式专用首页',
          // auth: true,
          keepAlive: true,
          author: 'suxuan', // 作者
          tags: [], // 标签
          desc: '内部调试专用首页' // 描述 备注 可用于备注参数
          // rank: 93 // 在埋点收集平台展示的优先顺序
        },
        component: () => import('@views/index/index/index.vue') //
      }
    ]
  },
  {
    /***
     * 首页
     */
    path: '/',
    redirect: '/index',
    component: () => import('@views/index-v2/index.vue'),
    children: [
      {
        path: 'index',
        name: 'index',
        meta: {
          title: '首页',
          // auth: true,
          keepAlive: true,
          author: 'yuyingchun', // 作者
          tags: [], // 标签
          desc: '首页', // 描述 备注 可用于备注参数
          rank: 93 // 在埋点收集平台展示的优先顺序
        },
        component: () => import('@views/index-v2/index/index.vue') //
      },
      {
        // 红包列表 我的-我的红包
        path: 'redpacklist',
        name: 'redpacklist',
        meta: {
          title: '红包卡券',
          auth: true,
          author: 'yuyingchun', // 作者
          tags: ['20210625迁移自offline-place'], // 标签
          desc: '我的-我的红包' // 描述 备注 可用于备注参数
        },
        component: () => import('@views/redpacklist/app.vue')
      }
    ]
  },
  /***
   * 同城合伙人
   */
  // {
  //   path: '/local-partner',
  //   name: 'local-partner',
  //   redirect: '/local-partner/index',
  //   component: () => import('@views/local-partner/index.vue'),
  //   children: [
  // {
  //   path: 'index',
  //   name: 'local-partner-index',
  //   meta: {
  //     title: '同城',
  //     keepAlive: true,
  //     author: 'yuyingchun', // 作者
  //     tags: [], // 标签
  //     desc: '同城', // 描述 备注 可用于备注参数
  //     rank: 119 // 在埋点收集平台展示的优先顺序
  //   },
  //   component: () => import('@/views/local-partner/main/index.vue')
  // },
  // {
  //   path: 'rank-list',
  //   name: 'rank-list',
  //   meta: {
  //     title: '同城站点排名',
  //     keepAlive: true,
  //     author: 'yuyingchun', // 作者
  //     tags: [], // 标签
  //     desc: '同城站点排名', // 描述 备注 可用于备注参数
  //     rank: 120 // 在埋点收集平台展示的优先顺序
  //   },
  //   component: () => import('@/views/local-partner/rank-list/index.vue')
  // }
  // ]
  // },
  {
    /***
     * 我的（个人中心-我的）
     */
    path: '/my-home',
    name: 'home',
    redirect: '/my-home/home-index',
    component: () => import('@views/my-home/index.vue'),
    children: [
      {
        path: 'home-index',
        name: 'home-index',
        meta: {
          title: '个人中心',
          // auth: true,
          keepAlive: true,
          desc: '个人中心',
          rank: 92 // 在埋点收集平台展示的优先顺序
        },
        component: () => import('@views/my-home/home-index/index.vue')
      },
      {
        path: 'setting',
        name: 'setting',
        meta: {
          title: '设置',
          auth: true
        },
        component: () => import('@views/my-home/setting/index.vue')
      },
      {
        path: 'user-info',
        name: 'user-info',
        meta: {
          title: '个人资料',
          auth: true
        },
        component: () => import('@views/my-home/setting/user-info.vue')
      },
      {
        path: 'about',
        name: 'about',
        meta: {
          title: '关于采货侠',
          auth: false
        },
        component: () => import('@views/my-home/setting/about.vue')
      },
      // {
      //   path: 'scan-to-order',
      //   name: 'scan-to-order',
      //   meta: {
      //     title: '扫描条形码'
      //   },
      //   component: () => import('@views/my-home/scan-to-order/index.vue')
      // },
      {
        path: 'faq',
        name: 'faq',
        meta: {
          title: '常见问题'
        },
        component: () => import('@/views/my-home/faq/index.vue')
      },
      {
        path: 'faq-detail',
        name: 'faq-detail',
        meta: {
          title: '问题详情'
        },
        component: () => import('@/views/my-home/faq-detail/index.vue')
      }
    ]
  },
  {
    path: '/real-deal-price',
    name: 'real-deal-price',
    component: () => import('@views/real-deal-price/index.vue'),
    children: [
      {
        path: 'tradedTurnoverInfo',
        name: 'tradedTurnoverInfo',
        meta: {
          title: '成交趋势图',
          auth: true,
          author: 'gaoqi',
          desc: '真实成交价-成交趋势图',
          rank: 8
        },
        component: () => import('@/views/real-deal-price/tradedTurnoverInfo/index.vue')
      },
      {
        path: 'model-select',
        name: 'model-select',
        meta: {
          title: '选择品牌',
          auth: false,
          author: 'gaoqi',
          desc: '真实成交价-选择品牌',
          rank: 8
        },
        component: () => import('@/views/real-deal-price/model-select/index.vue')
      },
      {
        path: 'list',
        name: 'list',
        meta: {
          title: '真实成交价',
          auth: true,
          author: 'gaoqi',
          desc: '真实成交价-主页',
          rank: 8
        },
        component: () => import('@/views/real-deal-price/list/index.vue')
      },
      {
        path: 'detail',
        name: 'detail',
        meta: {
          title: '成交详情',
          auth: true,
          author: 'gaoqi',
          desc: '真实成交价-成交详情',
          rank: 8
        },
        component: () => import('@/views/real-deal-price/detail/index.vue')
      },
      {
        path: 'search',
        name: 'search',
        meta: {
          title: '机型搜索',
          auth: true,
          author: 'gaoqi',
          desc: '真实成交价-机型搜索',
          rank: 8
        },
        component: () => import('@/views/real-deal-price/search/index.vue')
      }
      // {
      //   path: 'index',
      //   name: 'publishIndex',
      //   meta: {
      //     title: '页面不存在',
      //     keepAlive: true
      //   },
      //   component: () =>
      //     import(
      //       /* webpackChunkName: "real-deal-price-index" */
      //       '@views/real-deal-price/real-deal-price-index/index.vue'
      //     )
      // }
    ]
  },
  // {
  //   /***
  //    * 买卖家等级
  //    */
  //   path: '/buyer-seller-grade',
  //   name: 'buyer-seller-grade',
  //   redirect: '/buyer-seller-grade/detail',
  //   component: () => import('@views/buyer-seller-grade/index.vue'),
  //   children: [
  //     {
  //       path: 'detail',
  //       name: 'buyer-seller-grade-detail',
  //       meta: {
  //         title: '会员中心',
  //         auth: true,
  //         author: 'yuyingchun', // 作者
  //         tags: [], // 标签
  //         desc: '买卖家等级页面' // 描述 备注 可用于备注参数
  //       },
  //       component: () => import('@views/buyer-seller-grade/detail/index.vue')
  //     },
  //     {
  //       path: 'gmv-particular',
  //       name: 'buyer-seller-grade-gmv-particular',
  //       meta: {
  //         title: 'GMV 明细',
  //         auth: true,
  //         author: '郭凯铭', // 作者
  //         tags: [], // 标签
  //         desc: 'GMV 明细页面' // 描述 备注 可用于备注参数
  //       },
  //       /* webpackChunkName: "gmv-particular" */
  //       component: () => import('@views/buyer-seller-grade/gmv-particular/index.vue')
  //     }
  //   ]
  // },
  {
    /***
     * 搜索中间页面
     */
    path: '/search/middle-page',
    name: 'middle-page',
    component: () => import('@views/search/middle-page.vue')
  },
  /***
   * m页短链接 唤醒页面
   */
  {
    path: '/wakeup-page',
    name: 'wakeup-page',
    component: () => import('@views/wakeup-page/index.vue')
  },
  /***
   * 下载 验机侠页面
   */
  {
    path: '/down-load',
    name: 'down-load',
    component: () => import('@views/down-load-app/index.vue')
  },
  /***
   * 报价单页面
   */
  // {
  //   path: '/quotation',
  //   name: 'quotation',
  //   redirect: '/quotation/index',
  //   component: () => import('@views/quotation/index.vue'),
  //   children: [
  //     {
  //       path: 'index',
  //       name: 'quotation-index',
  //       meta: {
  //         title: '生成报价单',
  //         auth: true,
  //         keepAlive: true
  //       },
  //       component: () => import('@views/quotation/home/index.vue')
  //     }
  //   ]
  // },
  /***
   * 暗拍
   */
  {
    path: '/secret-auction',
    name: 'secret-auction',
    redirect: '/secret-auction/detail',
    component: () => import('@views/secret-auction/index.vue'),
    children: [
      // 列表页面的path和name在代码逻辑中有强耦合性 请务必保证一致
      {
        path: 'mobile-list',
        name: 'mobile-list',
        meta: {
          title: '手机暗拍列表',
          keepAlive: true,
          auth: false,
          author: 'yuyingchun', // 作者
          tags: [], // 标签
          desc: '手机暗拍列表', // 描述 备注 可用于备注参数
          rank: 100 // 在埋点收集平台展示的优先顺序
        },
        component: () => import('@/views/secret-auction/list/index.vue')
      },
      // 列表页面的path和name在代码逻辑中有强耦合性 请务必保证一致
      {
        path: 'tablets-list',
        name: 'tablets-list',
        meta: {
          title: '平板暗拍列表',
          keepAlive: true,
          auth: false,
          author: 'yuyingchun', // 作者
          tags: [], // 标签
          desc: '平板暗拍列表', // 描述 备注 可用于备注参数
          rank: 99 // 在埋点收集平台展示的优先顺序
        },
        component: () => import('@/views/secret-auction/list/index.vue')
      },
      // 列表页面的path和name在代码逻辑中有强耦合性 请务必保证一致
      // {
      //   path: 'allowance-list',
      //   name: 'allowance-list',
      //   meta: {
      //     title: '捡漏专场',
      //     keepAlive: true,
      //     author: 'yuyingchun', // 作者
      //     tags: [], // 标签
      //     desc: '捡漏专场', // 描述 备注 可用于备注参数
      //     rank: 91 // 在埋点收集平台展示的优先顺序
      //   },
      //   component: () => import('@/views/secret-auction/list/index.vue')
      // },

      /* ❗❗❗❗❗----------------------------------------------- */
      // ❗❗❗❗❗当前下午场保留，暂时注释先不要下线 - 2025.11.06下线废弃路由分支❗❗❗❗❗
      /* ------------------------------------------------ */
      // {
      //   path: 'matinee-list',
      //   name: 'matinee-list',
      //   meta: {
      //     title: '下午场',
      //     keepAlive: true,
      //     auth: false,
      //     author: 'yuyingchun', // 作者
      //     tags: [], // 标签
      //     desc: '暗拍手机下午场', // 描述 备注 可用于备注参数
      //     rank: 90 // 在埋点收集平台展示的优先顺序
      //   },
      //   component: () => import('@/views/secret-auction/list/index.vue')
      // },
      // 列表页面的path和name在代码逻辑中有强耦合性 请务必保证一致
      // {
      //   path: 'direct-list',
      //   name: 'direct-list',
      //   meta: {
      //     title: '直卖手机',
      //     keepAlive: true,
      //     author: 'lvbaoyu', // 作者
      //     tags: [], // 标签
      //     desc: '合伙人直卖手机卖场', // 描述 备注 可用于备注参数
      //     rank: 90 // 在埋点收集平台展示的优先顺序
      //   },
      //   component: () => import('@/views/direct-sale/list/index.vue')
      // },
      {
        path: 'history-bid',
        name: 'history-bid',
        meta: {
          title: '历史出价',
          keepAlive: true,
          author: 'lvbaoyu', // 作者
          tags: [], // 标签
          desc: '历史出价页面', // 描述 备注 可用于备注参数
          rank: 97 // 在埋点收集平台展示的优先顺序
        },
        component: () => import('@views/secret-auction/history-bid/index.vue')
      },
      {
        path: 'detail',
        name: 'secret-auction-detail',
        meta: {
          title: '商品详情',
          keepAlive: true,
          auth: false,
          author: 'xiexing', // 作者
          tags: [], // 标签
          desc: '暗拍商品详情（包括手机【主卖场、捡漏、下午场】和 平板）', // 描述 备注 可用于备注参数
          rank: 98 // 在埋点收集平台展示的优先顺序
        },
        component: () => import('@views/secret-auction/detail/index.vue')
      },
      {
        path: 'search',
        name: 'secret-search',
        meta: {
          title: '暗拍搜索',
          keepAlive: true,
          author: 'yuyingchun', // 作者
          tags: [], // 标签
          desc: '暗拍搜索页面', // 描述 备注 可用于备注参数
          rank: 99 // 在埋点收集平台展示的优先顺序
        },
        component: () => import('@views/secret-auction/search/index.vue')
      },
      // {
      //   path: 'index',
      //   name: 'secret-auction-index',
      //   meta: {
      //     title: '商品详情',
      //     keepAlive: true
      //   },
      //   component: () => import('@views/secret-auction/index/index.vue')
      // },
      {
        path: 'qc-report',
        name: 'qc-report',
        meta: {
          title: '验机报告',
          keepAlive: true,
          author: 'bijiayao', // 作者
          tags: [], // 标签
          desc: '验机报告' // 描述 备注 可用于备注参数
        },
        component: () => import('@views/secret-auction/qc-report/index.vue')
      },
      // {
      //   path: 'offer-limit',
      //   name: 'offer-limit',
      //   meta: {
      //     title: '暗拍累计付款金额',
      //     auth: true,
      //     keepAlive: true,
      //     author: 'xiexing', // 作者
      //     tags: [], // 标签
      //     desc: '暗拍累计付款金额' // 描述 备注 可用于备注参数
      //   },
      //   component: () => import('@views/secret-auction/offer-limit/index.vue')
      // },
      {
        path: 'grade',
        name: 'grade',
        meta: {
          title: '等级列表',
          auth: false,
          desc: '等级列表'
        },
        component: () => import('@views/secret-auction/grade/index.vue')
      },
      {
        // 我的筛选页面
        path: 'my-search',
        name: 'my-search',
        meta: {
          title: '我的筛选',
          author: 'duanwenxiang', // 作者
          desc: '我的筛选页面' // 描述 备注 可用于备注参数
        },
        component: () => import('@views/secret-auction/my-search/index.vue')
      }
    ]
  },
  /***
   * 新一口价
   */
  {
    path: '/new-one-price',
    name: 'buy-now-price',
    redirect: '/new-one-price/detail',
    component: () => import('@views/buy-now-price/index.vue'),
    children: [
      {
        path: 'list',
        name: 'new-one-price-list',
        meta: {
          title: '一口价专区',
          keepAlive: true,
          auth: false,
          author: 'xiexing', // 作者
          tags: [], // 标签
          desc: '一口价卖场', // 描述 备注 可用于备注参数
          rank: 91 // 在埋点收集平台展示的优先顺序
        },
        component: () => import('@views/buy-now-price/list/index.vue')
      },
      {
        path: 'video-list',
        name: 'new-one-price-video-list',
        meta: {
          // title: '一口价视频专区',
          auth: false
        },
        component: () => import('@views/buy-now-price/video-list/index.vue')
      },
      {
        path: 'detail',
        name: 'new-one-price-detail',
        meta: {
          title: '详情',
          keepAlive: true,
          auth: false,
          author: '', // 作者
          tags: [], // 标签
          desc: '新一口价商品详情', // 描述 备注 可用于备注参数
          rank: 96 // 在埋点收集平台展示的优先顺序
        },
        component: () => import('@views/buy-now-price/detail/index.vue')
      },
      {
        path: 'video-detail',
        name: 'new-one-price-video-detail',
        meta: {
          title: '商品详情',
          auth: false
        },
        component: () => import('@views/buy-now-price/video-detail/index.vue')
      },
      // {
      //   path: 'old-enter-order',
      //   name: 'new-one-price-old-enter-order',
      //   meta: {
      //     title: '确认下单',
      //     keepAlive: true,
      //     author: 'longjimiao', // 作者
      //     tags: [], // 标签
      //     desc: '旧一口价确认下单页面--用于保卖业务', // 描述 备注 可用于备注参数
      //     rank: 101 // 在埋点收集平台展示的优先顺序
      //   },
      //   component: () => import('@views/buy-now-price/old-enter-order/index.vue')
      // },
      {
        path: 'enter-order',
        name: 'new-one-price-enter-order',
        meta: {
          title: '确认下单',
          keepAlive: true,
          author: '', // 作者
          tags: [], // 标签
          desc: '新一口价确认下单页面', // 描述 备注 可用于备注参数
          rank: 95 // 在埋点收集平台展示的优先顺序
        },
        component: () => import('@views/buy-now-price/enter-order/index.vue')
      },
      {
        path: 'search',
        name: 'new-one-price-search',
        meta: {
          title: '搜索商品',
          author: 'xiexing', // 作者
          tags: [], // 标签
          desc: '新一口价搜索页面', // 描述 备注 可用于备注参数
          rank: 94 // 在埋点收集平台展示的优先顺序
        },
        component: () => import('@views/buy-now-price/search/index.vue')
      },
      {
        path: 'wholesale-detail',
        name: 'new-one-price-wholesale-detail',
        meta: {
          title: '批发详情',
          author: 'xiexing', // 作者
          tags: [], // 标签
          desc: '批发详情页面', // 描述 备注 可用于备注参数
          rank: 94 // 在埋点收集平台展示的优先顺序
        },
        component: () => import('@views/buy-now-price/wholesale-detail/index.vue')
      }
    ]
  },
  {
    // 我的参拍页面
    path: '/stores/my-auction',
    name: 'stores/my-auction',
    meta: {
      title: '我的参拍',
      keepAlive: true,
      author: '', // 作者
      tags: [], // 标签
      desc: '我的参拍页面' // 描述 备注 可用于备注参数
    },
    component: () => import('@views/secret-auction/stores/my-auction/index.vue')
  },
  // {
  //   // 我的报价页面
  //   path: '/stores/my-quoted',
  //   name: 'stores/my-quoted',
  //   meta: {
  //     title: '我的报价',
  //     author: 'lvbaoyu', // 作者
  //     tags: [], // 标签
  //     desc: '我的报价页面' // 描述 备注 可用于备注参数
  //   },
  //   component: () => import('@views/direct-sale/my-offer/index.vue')
  // },
  // {
  //   // 我的关注页面
  //   path: '/stores/my-follow',
  //   name: 'stores/my-follow',
  //   meta: {
  //     title: '我的关注',
  //     keepAlive: true,
  //     auth: true,
  //     author: 'guokaiming', // 作者
  //     tags: [], // 标签
  //     desc: '我关注的商品 靓机汇等特殊场景使用' // 描述 备注 可用于备注参数
  //   },
  //   component: () => import('@views/secret-auction/stores/my-follow/index.vue')
  // },
  // {
  //   // 我的关注页面
  //   path: '/stores/all-my-follow',
  //   name: 'stores/all-my-follow',
  //   meta: {
  //     title: '我的关注',
  //     keepAlive: true,
  //     auth: true,
  //     author: 'bijiayao', // 作者
  //     tags: [], // 标签
  //     desc: '我关注的商品  采货侠使用' // 描述 备注 可用于备注参数
  //   },
  //   component: () => import('@views/secret-auction/stores/all-my-follow/index.vue')
  // },
  {
    // 等级说明
    path: '/level-desc',
    name: 'level-desc',
    meta: {
      title: '等级说明',
      author: 'lvbaoyu', // 作者
      tags: [], // 标签
      desc: '等级说明' // 描述 备注 可用于备注参数
    },
    component: () => import('@views/level-desc/index.vue')
  },
  /***
   * 营销活动页面
   */
  {
    path: '/activity',
    name: 'activity',
    redirect: '/activity/list',
    component: () => import('@views/activity/index.vue'),
    children: [
      {
        path: 'list',
        name: 'list',
        meta: {
          title: '活动列表',
          keepAlive: true,
          author: '', // 作者
          tags: [], // 标签
          desc: '营销活动的活动列表页' // 描述 备注 可用于备注参数
        },
        component: () => import('@views/activity/list/index.vue')
      },
      {
        path: 'detail',
        name: 'activity-detail',
        meta: {
          title: '活动达成情况',
          keepAlive: true,
          author: '', // 作者
          tags: [], // 标签
          desc: '活动详情页' // 描述 备注 可用于备注参数
        },
        component: () => import('@views/activity/detail/index.vue')
      }
    ]
  },
  // 注销账户
  {
    path: '/write-off',
    name: 'write-off',
    redirect: '/write-off/confirm',
    component: () => import('@views/write-off/index.vue'),
    meta: {
      title: '注销账户',
      author: 'lvbaoyu', // 作者
      tags: [], // 标签
      desc: '注销账户'
    },
    children: [
      {
        path: 'confirm',
        name: 'confirm',
        component: () => import('@views/write-off/confirm/index.vue'),
        meta: {
          title: '注销账户确认',
          author: 'lvbaoyu', // 作者
          tags: [], // 标签
          desc: '注销账户-确认',
          // token用于页面逻辑判断，请勿随意更改，如有需求，请联系作者
          token: 'write-off-confirm'
        }
      },
      {
        path: 'notice',
        name: 'notice',
        component: () => import('@views/write-off/notice/index.vue'),
        meta: {
          title: '账户注销须知',
          author: 'lvbaoyu', // 作者
          tags: [], // 标签
          desc: '注销账户-须知',
          // token用于页面逻辑判断，请勿随意更改，如有需求，请联系作者
          token: 'write-off-notice'
        }
      }
    ]
  },
  // {
  //   // 热销榜
  //   path: '/hot-sale',
  //   name: 'hot-sale',
  //   meta: {
  //     title: '采货侠热销榜',
  //     author: 'xiexing', // 作者
  //     tags: [], // 标签
  //     desc: '采货侠热销榜' // 描述 备注 可用于备注参数
  //   },
  //   component: () => import('@views/hot-sale/index/index.vue')
  // },
  // 以旧换优
  // {
  //   path: '/replacement',
  //   name: 'replacement',
  //   redirect: '/replacement/index',
  //   component: () => import('@views/replacement/index.vue'),
  //   children: [
  //     {
  //       path: 'power-sell',
  //       name: 'replacement-power-sell',
  //       meta: {
  //         title: '手机服务卡购买',
  //         author: 'lvbaoyu', // 作者
  //         tags: [], // 标签
  //         desc: '手机服务卡购买' // 描述 备注 可用于备注参数
  //       },
  //       component: () => import('@/views/replacement/power-sell/index.vue')
  //     },
  //     {
  //       path: 'power-list',
  //       name: 'replacement-power-list',
  //       meta: {
  //         title: '手机服务卡列表',
  //         author: 'lvbaoyu', // 作者
  //         tags: [], // 标签
  //         desc: '手机服务卡列表' // 描述 备注 可用于备注参数
  //       },
  //       component: () => import('@/views/replacement/power-list/index.vue')
  //     },
  //     {
  //       path: 'power-detail',
  //       name: 'replacement-power-detail',
  //       meta: {
  //         title: '手机服务卡详情',
  //         author: 'lvbaoyu', // 作者
  //         tags: [], // 标签
  //         desc: '手机服务卡详情' // 描述 备注 可用于备注参数
  //       },
  //       component: () => import('@/views/replacement/power-detail/index.vue')
  //     },
  //     {
  //       path: 'product-list',
  //       name: 'replacement-product-list',
  //       meta: {
  //         title: '商品列表',
  //         author: 'lvbaoyu', // 作者
  //         tags: [], // 标签
  //         desc: '商品列表' // 描述 备注 可用于备注参数
  //       },
  //       component: () => import('@/views/replacement/product-list/index.vue')
  //     },
  //     {
  //       path: 'product-detail',
  //       name: 'replacement-product-detail',
  //       meta: {
  //         title: '商品详情',
  //         author: 'lvbaoyu', // 作者
  //         tags: [], // 标签
  //         desc: '商品详情' // 描述 备注 可用于备注参数
  //       },
  //       component: () => import('@/views/replacement/product-detail/index.vue')
  //     },
  //     {
  //       path: 'confirm-order',
  //       name: 'replacement-confirm-order',
  //       meta: {
  //         title: '确认下单',
  //         author: 'lvbaoyu', // 作者
  //         tags: [], // 标签
  //         desc: '确认下单' // 描述 备注 可用于备注参数
  //       },
  //       component: () => import('@/views/replacement/confirm-order/index.vue')
  //     },
  //     {
  //       path: 'pay-success',
  //       name: 'replacement-pay-success',
  //       meta: {
  //         title: '支付成功',
  //         author: 'lvbaoyu', // 作者
  //         tags: [], // 标签
  //         desc: '支付成功' // 描述 备注 可用于备注参数
  //       },
  //       component: () => import('@/views/replacement/pay-success/index.vue')
  //     },
  //     {
  //       path: 'product-pay-success',
  //       name: 'replacement-product-pay-success',
  //       meta: {
  //         title: '支付成功',
  //         author: 'lvbaoyu', // 作者
  //         tags: [], // 标签
  //         desc: '支付成功' // 描述 备注 可用于备注参数
  //       },
  //       component: () => import('@/views/replacement/product-pay-success/index.vue')
  //     }
  //   ]
  // },

  {
    // 卖家落地页
    path: '/seller-center',
    name: 'seller-center',
    meta: {
      title: '卖家详情',
      author: 'bijiayao', // 作者
      tags: [], // 标签
      desc: '卖家落地页' // 描述 备注 可用于备注参数
    },
    component: () => import('@views/seller-center/index.vue')
  },
  {
    // 站点落地页
    path: '/site-center',
    name: 'site-center',
    meta: {
      title: '站点详情',
      author: 'bijiayao', // 作者
      tags: [], // 标签
      desc: '站点落地页' // 描述 备注 可用于备注参数
    },
    component: () => import('@views/site-center/index.vue')
  },
  // {
  //   // 一根线智能验机报告
  //   path: '/intelligent-tester-report',
  //   name: 'intelligent-tester-report',
  //   meta: {
  //     title: '报告详情',
  //     author: 'bijiayao', // 作者
  //     tags: [], // 标签
  //     desc: '报告详情' // 描述 备注 可用于备注参数
  //   },
  //   component: () => import('@views/intelligent-tester-report/index.vue')
  // },
  {
    // 智能验机充值记录
    path: '/recharge-record',
    name: 'recharge-record',
    meta: {
      title: '充值记录',
      author: 'longjimiao',
      tags: [], // 标签
      desc: '智能验机2期充值记录'
    },
    component: () => import('@views/helper-pages/recharge-record/index.vue')
  },
  /***
   * 仅浏览模式
   */
  {
    path: '/browse-mode',
    name: 'browse-mode',
    redirect: '/browse-mode/auction-list',
    component: () => import('@views/browse-mode/index.vue'),
    children: [
      {
        path: 'auction-list',
        name: 'auction-list',
        meta: {
          title: '暗拍卖场',
          keepAlive: true,
          author: 'xiexing', // 作者
          tags: [], // 标签
          desc: '浏览模式', // 描述 备注 可用于备注参数
          rank: 119 // 在埋点收集平台展示的优先顺序
        },
        component: () => import('@/views/browse-mode/auction-list/index.vue')
      }
    ]
  },
  // 资源机落地页
  {
    path: '/resource-machine',
    name: 'resource-machine',
    component: () => import('@views/resource-machine/index.vue'),
    children: [
      {
        path: 'list',
        name: 'list',
        meta: {
          title: '资源机',
          auth: false,
          author: 'gaoqi',
          desc: '资源机-列表'
        },
        component: () => import('@/views/resource-machine/list/index.vue')
      },
      {
        path: 'detail',
        name: 'detail',
        meta: {
          title: '资源机详情',
          auth: false,
          author: 'gaoqi',
          desc: '资源机-详情'
        },
        component: () => import('@/views/resource-machine/detail/index.vue')
      }
    ]
  },
  /***
   * 添加企微二维码页面
   */
  {
    path: '/add-worker-qr',
    name: 'add-worker-qr',
    component: () => import('@views/add-worker-qr/index.vue')
  },
  // 报告预览
  {
    path: '/report-view',
    name: 'report-view',
    component: () => import('@views/report-view/index.vue'),
    children: [
      {
        path: 'market-report',
        name: 'market-report',
        meta: {
          title: '市场报告',
          auth: false,
          author: 'xiexing',
          desc: '市场报告'
        },
        component: () => import('@/views/report-view/market-report/index.vue')
      }
    ]
  },
  /* 身份认证页，push方式访问，客户端不提供入口 */
  {
    path: '/identity-auth',
    name: 'identity-auth',
    meta: {
      title: '身份认证'
    },
    component: () => import('@views/identity-auth/index.vue')
  },
  {
    path: '/store',
    name: 'store',
    redirect: '/store/store-index',
    component: () => import('@views/store/index.vue'),
    children: [
      {
        path: 'store-index',
        name: 'store-index',
        meta: {
          title: '站点详情',
          auth: true,
          author: 'xiexing',
          desc: '站点详情'
        },
        component: () => import('@/views/store/store-index/index.vue')
      }
    ]
  },
  /* 会员支付结果页 */
  {
    path: '/member-pay-success',
    name: 'member-pay-success',
    meta: {
      title: '支付成功'
    },
    component: () => import('@views/member-pay-success/index.vue')
  },
  {
    path: '/404',
    name: '404',
    meta: {
      title: '页面不存在'
    },
    component: () => import('@views/404/index.vue')
  }
  /* 动态匹配拿不到上一个路由信息，暂不使用 */
  // {
  //   path: '/:pathMatch(.*)*',
  //   redirect: '/404'
  // }
]
